// @ts-strict-ignore
import { setContext } from "@apollo/client/link/context";
import { getThumbmark } from "@thumbmarkjs/thumbmarkjs";

let fingerprint: string | undefined;

/**
 * An apollo link that sets X-FS-CLIENT-FINGERPRINT header which contains
 * the current device fingerprint
 */
export const fingerprintLink = setContext(async (_, { headers }) => {
  if (!fingerprint) {
    try {
      const result = await getThumbmark();
      fingerprint = result?.thumbmark;
    } catch (error) {
      fingerprint = undefined;
    }
  }

  return {
    headers: {
      ...headers,
      "x-fs-client-fingerprint": fingerprint,
    },
  };
});
